import type {LatLng} from "./types";

export function toLatLng<T extends {lat?: number; lon?: number}>(location: T): LatLng {
    return {
        lat: location.lat || 0, // FIXME: fallback not good
        lng: location.lon || 0, // FIXME: fallback not good
    };
}
